import {
	FORM_NOTICES,
	FORM_NOTICE
} from "../routes";

function NoticeAdminService(
	api,
	$logger
) {
	const service = this;

	service.getNotices = (formId) => {
		return api.get(FORM_NOTICES(formId, true)).then(notices => {
			return notices.sort((a, b) => a.Id > b.Id ? -1 : 1);
		});
	};

	service.getNotice = (formId, noticeId) => {
		return api.get(FORM_NOTICE(formId, noticeId));
	};

	service.createNotice = (formId, notice) => {
		return api.post(FORM_NOTICES(formId), notice);
	};

	service.updateNotice = (formId, noticeId, notice) => {
		return api.put(FORM_NOTICE(formId, noticeId), notice);
	};

	return service;
}

export default angular
	.module("vesl.services.notice-admin-service", [])
	.service("noticeAdminService", NoticeAdminService).name;
